import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import PrivateRoute from './components/PrivateRoute';
import UserList from './pages/UserList';
import ExcelProcessor from './pages/ExcelProcessor';
import DocsProcessor from './pages/DocsProcessor';
import EntityForm from './pages/EntityForm';
import LayoutWithNavbar from './components/LayoutWithNavbar';


const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: (
      <PrivateRoute>
        <LayoutWithNavbar />
      </PrivateRoute>
    ),
    children: [
      { path: "/home", element: <Home /> },
      { path: "/entity-form/:id", element: <EntityForm /> },
      { path: "/admin/users", element: <UserList /> },
      { path: "/admin/excel", element: <ExcelProcessor /> },
      { path: "/admin/docs", element: <DocsProcessor /> },
    ],
  },
  {
    path: "*",
    element: <LoginPage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;